import { handleSidebarImages } from '~src/sidebar/index';
import { modifyState } from '~src/state';

export const onChangeImagesTagValue = async (event) => {
  if (event.params.data) {
    let sidebarCurrentImagesTag = event.params.data.text;
    modifyState(
      'sidebarCurrentImagesTag',
      sidebarCurrentImagesTag.toLowerCase()
    );
  } else {
    modifyState('sidebarCurrentImagesTag', 'NO_TAG');
  }
  await handleSidebarImages();
};
